import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { PortalService } from "../../services/portal-service.service";
import { Activations } from "../../models/activations";
import { Contracts } from "../../models/contracts";
import { ContractSummaryComponent } from "../contract-summary/contract-summary.component";

@Component({
  standalone: false,
  selector: "app-license-overview",
  templateUrl: "./license-overview.component.html",
  styleUrls: ["./license-overview.component.scss"],
})
export class LicenseOverviewComponent implements OnInit {
  active = new Array<Activations>();
  surrendered = new Array<Activations>();
  expired = new Array<Activations>();
  activeTab = 1;
  @Input() contract: Contracts;
  @Input() showComments = false;
  @ViewChild("contractSummary", { static: false })
  contractSummary: ContractSummaryComponent;
  showTokens = false;
  loading = true;
  constructor(private portalService: PortalService) {}

  ngOnInit() {
    this.getActivations(this.contract.id);
    this.showTokens = this.portalService.showTokens(this.contract);
    if (this.contractSummary) this.contractSummary.ngOnInit();
  }

  getActivations(contractId: number) {
    this.loading = true;
    return this.portalService.GetActivations(contractId, true).subscribe(
      (all: Activations[]) => {
        this.active = all.filter((a) => a.dateSurrendered == null && a.expiry.getTime() > new Date().getTime());
        this.surrendered = all.filter((a) => a.dateSurrendered != null);
        this.expired = all.filter((a) => a.expiry.getTime() < new Date().getTime());
        if (!this.contract.rental) {
          this.active = this.active.concat(this.expired);
          this.expired = [];
        }
        this.loading = false;
      },
      () => {
        this.loading = false;
      },
    );
  }
}
